import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, colors } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

export const container: CSSProperties = {};

export const scopeContainer: CSSProperties = {
  display: "grid",
  gap: "15px 4%",
  gridTemplateColumns: "48% 48%",
};

export const scope: CSSProperties = {
  width: "100%",
};

export const icon = {
  color: greys.slate,
  hoverColor: greys.standard,
};

export const labelMarginCorrection: CSSProperties = {
  margin: "3px 0 0 5px",
};

export const deleteButton: CSSProperties = {
  color: greys.slate,
  marginTop: spacing.std,
};

export const needsUpdate: CSSProperties = {};

export const calloutContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
};

export const calloutIcon: CSSProperties = {
  color: colors.yellow.darker,
  marginRight: 10,
};

export const calloutLabel: CSSProperties = {
  flexGrow: 1,
};

export const updateButton: CSSProperties = {
  color: colors.yellow.darker,
  justifyContent: "flex-end",
};

export const simpleRow: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  marginTop: 14,
};

export const simpleRowLabel: CSSProperties = {
  color: colors.green.darker,
  fontSize: "16px",
  lineHeight: "30px",
};

export const simpleRowCheckIcon: CSSProperties = {
  width: 12,
  height: 12,
  color: greys.white,
  marginRight: 3,
};

export const simpleRowInstalledPill: CSSProperties = {
  marginLeft: 14,
  backgroundColor: colors.green.darker,
  borderRadius: 4,
  color: greys.white,
  fontSize: "12px",
  padding: 3,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

export const simpleRowDeleteIconContainer: CSSProperties = {
  flex: 1,
  textAlign: "right",
};

export const simpleRowDeleteIcon: CSSProperties = {
  width: 24,
  height: 24,
  cursor: "pointer",
  color: greys.slate,
};
